import { Button, Flex, Typography } from "antd";
import React, { useEffect } from "react";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import moment from "moment";
import "../single-user-file/ambermodalfolder.scss";
import { AppModal } from "../../../components/common";


export default function AmberModalTable() {
  const { amberModalalt, setAmberModalAlt, selectedModalObjamber } =
    useUserFilesTabs();
  const { Paragraph } = Typography;
console.log(selectedModalObjamber,"selectedModalObjamberselectedModalObjamber");

  
  const title = () => (
    <Flex justify="space-between" align="center">
      <Typography className="font18">Reason for activating trigger*</Typography>
      <Flex className="titleBtns" gap={8} justify="center" align="center">
        <Paragraph className="lastEdited">
          Created on{" "}
          {moment(selectedModalObjamber?.createdAt).format("DD/MM/YY hh:mm A")}
        </Paragraph>
       </Flex>
    </Flex>
  );



  return (
    <AppModal
      className="goalsInTheraphyModal"
      title={title()}
      open={amberModalalt}
      onCancel={() => {
        setAmberModalAlt(false);
      }}
      footer={<>
      <Button className="value_btn"
       onClick={() => {
        setAmberModalAlt(false);
      }}
      >
        Go Back
      </Button>
      </>}
    >
      
       <p>{selectedModalObjamber?.reason}</p>
      
    </AppModal>
  );
}
